import { DirtyRepliersListingPropertyType } from '../../types/repliers/UnsanitizedRepliersListingPropertyType';
import { RepliersListingPropertyType } from '../../types/repliers/RepliersListingPropertyType';
import { RepliersListing } from '../../types/repliers/RepliersListing';

export default function sanitizeRepliersPropertyType(
  repliersListing: RepliersListing,
): RepliersListingPropertyType {
  const { propertyType } = repliersListing.details;

  switch (propertyType) {
    case DirtyRepliersListingPropertyType.ResidentialITSO:
      return RepliersListingPropertyType.Land; // NOTE: ITSO listings with a 'Residential' propertyType all seem to be Land
    case DirtyRepliersListingPropertyType.FreeholdTownhouseITSO:
      return RepliersListingPropertyType.FreeholdTownhouse;
    case DirtyRepliersListingPropertyType.CondoApartmentITSO:
      return RepliersListingPropertyType.CondoApartment;
    case DirtyRepliersListingPropertyType.StoreWithAptOffcITSO:
      return RepliersListingPropertyType.StoreWithAptOffice;
    case DirtyRepliersListingPropertyType.LandITSO:
      return RepliersListingPropertyType.Land;
  }

  return propertyType as RepliersListingPropertyType;
}
